import * as React from 'react'
import { useState, useEffect } from 'react'
import { Button, Card, Form, Row, Col, Modal, Badge } from 'react-bootstrap'
import { BsSearch, BsFileEarmarkExcel, BsShieldCheck } from 'react-icons/bs'
import * as XLSX from 'xlsx'
import DataTable from 'react-data-table-component'
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo'
import DTOEmpleado from './DTO/DTOEmpleado'
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados'
import DTOEmpleadoResponse from './DTO/DTOEmpleadoResponse'
import ControlContrasenas from '../CatSistemas/ControlContrasenas'


export interface ICatSistemasEmpleadosProps {}

export default function CatSistemasEmpleados(props: ICatSistemasEmpleadosProps) {
  // --- ESTADOS PARA LA TABLA ---
  const [Data, setData] = useState<Array<DTOEmpleado>>([])
  const [filteredData, setFilteredData] = useState<Array<DTOEmpleado>>([])
  const [filtro, setFiltro] = useState('')
  
  // --- ESTADOS PARA MENSAJES/ALERTAS ---
  const [show, setShowMsg] = useState(false)
  const [msg, setMsg] = useState('')
  const [header, setHeader] = useState('')
  const msgColor = 'primary'

  // --- ESTADOS PARA EL MODAL DE SISTEMAS ---
  const [showModalSistemas, setShowModalSistemas] = useState(false)
  
  // Datos de RH (Solo Lectura - Lo que IT necesita ver)
  const [numEmpleado, setNumEmpleado] = useState('')
  const [name, setName] = useState('')
  const [ac, setAc] = useState(0)
  const [departamento, setDepartamento] = useState('')
  const [oficina, setOficina] = useState('')
  const [activo, setActivo] = useState(false)
  const [fechaBajaEfectiva, setFechaBajaEfectiva] = useState('')

  // Datos de IT (Editables)
  const [tieneAccesosReloj, setTieneAccesosReloj] = useState(false)
  const [altaEnSistemas, setAltaEnSistemas] = useState(false)
  const [correoEmpresa, setCorreoEmpresa] = useState('')
  const [modalidad, setModalidad] = useState('')
  const [estatusFiltro, setEstatusFiltro] = useState('todos') // Opciones: 'todos', 'activos', 'inactivos'

  // ---> NUEVO: ESTADO PARA COMENTARIOS DE IT <---
  const [comentariosSistemas, setComentariosSistemas] = useState('')
  const [showModalKeys, setShowModalKeys] = useState(false);
const [selectedNumEmp, setSelectedNumEmp] = useState("");


  const handleOpenKeys = (num: string) => {
    setSelectedNumEmp(num);
    setShowModalKeys(true);
}

  // --- EFECTOS Y CARGA DE DATOS ---
  useEffect(() => {
    generarReporte();
  }, []);


  useEffect(() => {
    let resultado = Data;

    // 1. Filtramos por Estatus (Activo / Inactivo)
    if (estatusFiltro === 'activos') {
      resultado = resultado.filter((item) => item.activo);
    } else if (estatusFiltro === 'inactivos') {
      resultado = resultado.filter((item) => !item.activo);
    }

    // 2. Filtramos por Texto (Nombre o Número)
    if (filtro) {
      resultado = resultado.filter(
        (item) =>
          String(item.numEmpleado).toLowerCase().includes(filtro.toLowerCase()) ||
          item.name.toLowerCase().includes(filtro.toLowerCase())
      );
    }

    setFilteredData(resultado);
  }, [Data, filtro, estatusFiltro]); 
  // Se ejecuta solito cada vez que cambias la data, el texto o el estatus.
















  const generarReporte = () => {
    CatEmpleados.GetEmpleadosSistemas()
      .then((response) => {
        setData(response.data)
        setFilteredData(response.data)
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg(`Ocurrió un error al cargar datos: ${e}`)
        setShowMsg(true)
      })
  }

  const filtraReporte = (e: any) => {
    setFiltro(e.target.value)
    const filtered = Data.filter(
      (item) =>
        String(item.numEmpleado).toLowerCase().includes(e.target.value.toLowerCase()) ||
        item.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
        String(item.departamento).toLowerCase().includes(e.target.value.toLowerCase())
    )
    setFilteredData(filtered)
  }


  

  const downloadExcel = () => {
    
    const filteredColumns = filteredData.map(({ numEmpleado, ac, name, departamento, oficina, activo, fechaBajaEfectiva, correoElectronicoEmpresa, altaEnSistemas, fechaAltaRelojAccesos, fechaBajaAccesosReloj, fechaBajaSistemas }) => ({
      NumEmpleado: `\0${numEmpleado}`, 
      ID_Reloj: ac,
      Nombre: name,
      Departamento: departamento,
      Oficina: oficina,
      Estatus: activo ? 'Activo' : 'Baja',
      Fecha_Baja_RH: fechaBajaEfectiva ? new Date(fechaBajaEfectiva).toLocaleDateString() : 'N/A',
   
      Fecha_Baja_Reloj: fechaBajaAccesosReloj ? new Date(fechaBajaAccesosReloj).toLocaleDateString() : 'N/A',
      Fecha_Baja_IT: fechaBajaSistemas ? new Date(fechaBajaSistemas).toLocaleDateString() : 'N/A',
     
      Correo: correoElectronicoEmpresa || 'Pendiente',
      Reloj_Confirmado: fechaAltaRelojAccesos ? 'Sí' : 'No',
      Alta_IT_Finalizada: altaEnSistemas ? 'Sí' : 'No'
    }));
    exportExcel(filteredColumns, 'Reporte_Accesos_IT');
  };






  const exportExcel = (jsonData: any[], fileName: string) => {
    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    XLSX.utils.book_append_sheet(wb, ws, 'Sistemas IT');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  // --- LÓGICA DEL MODAL DE SISTEMAS ---
  const handleOpenModalSistemas = (empleado: DTOEmpleado) => {
    // 1. Cargamos datos de lectura (RH)
    setNumEmpleado(empleado.numEmpleado)
    setName(empleado.name)
    setAc(empleado.ac)
    setDepartamento(empleado.departamento)
    setOficina(empleado.oficina)
    setActivo(empleado.activo)
    setFechaBajaEfectiva(empleado.fechaBajaEfectiva || '')
    setModalidad(empleado.modalidad || '')

    // 2. Cargamos datos editables (IT)
    setTieneAccesosReloj(empleado.fechaAltaRelojAccesos ? true : false)
    setAltaEnSistemas(empleado.altaEnSistemas || false)
    setCorreoEmpresa(empleado.correoElectronicoEmpresa || '')

    
    setComentariosSistemas(empleado.comentarios || '')
    setShowModalSistemas(true)
  }





  const handleCloseModalSistemas = () => {
    setShowModalSistemas(false)
  }

  const handleSaveSistemas = () => {
    const payload = {
      NumEmpleado: numEmpleado,
      TieneAccesosReloj: tieneAccesosReloj,
      AltaEnSistemas: altaEnSistemas,
      CorreoElectronicoEmpresa: correoEmpresa, 
      Comentarios: comentariosSistemas, 
    }

    CatEmpleados.CompletarAltaSistemas(payload)
      .then((response) => {
        const result = response.data as DTOEmpleadoResponse
        if (result.success) {
          setHeader('Guardado Exitoso')
          setMsg(result.message)
          setShowMsg(true)
          generarReporte() 
          handleCloseModalSistemas()
        } else {
          setHeader('Error')
          setMsg(result.message)
          setShowMsg(true)
        }
      })
      .catch((e: any) => {
        setHeader('Error')
        setMsg(`Error al guardar en Sistemas: ${e?.message || e}`)
        setShowMsg(true)
      })
  }

  // --- DEFINICIÓN DE COLUMNAS PARA LA TABLA ---
  const columnsSistemas = [
    { name: 'No. Emp', selector: (row: DTOEmpleado) => String(row.numEmpleado), sortable: true, width: '120px' },
    { name: 'ID Reloj', selector: (row: DTOEmpleado) => row.ac, sortable: true, width: '90px' },
    { name: 'Nombre', selector: (row: DTOEmpleado) => row.name, sortable: true, wrap: true, width: '220px' },
    // { name: 'Departamento', selector: (row: DTOEmpleado) => row.departamento, sortable: true, width: '160px' },
    { name: 'Oficina', selector: (row: DTOEmpleado) => row.oficina, sortable: true, width: '130px' },
    {
      name: 'Estatus',
      width: '90px',
      cell: (row: DTOEmpleado) => (
        <Badge bg={row.activo ? 'success' : 'danger'}>
          {row.activo ? 'Activo' : 'Baja'}
        </Badge>
      ),
    },
    { 
      name: 'Fecha Baja', 
      selector: (row: DTOEmpleado) => row.fechaBajaEfectiva ? new Date(row.fechaBajaEfectiva).toLocaleDateString() : 'N/A', 
      sortable: true, 
      width: '150px' 
    },
    { name: 'Correo Asignado', selector: (row: DTOEmpleado) => row.correoElectronicoEmpresa || 'N/A', sortable: true, width: '180px' },

    // {
    //   name: 'Reloj&Acceso',
    //   width: '150px',
    //   cell: (row: DTOEmpleado) => {
    //     // Si es Home Office
    //     if (row.modalidad === 'LABHOME') {
    //       return <span className="badge bg-info text-dark">Reloj Virtual</span>;
    //     }
    //     // Si de plano no checa
    //     if (row.modalidad === 'NOINOUT' || row.modalidad === 'ON') {
    //       return <span className="badge bg-secondary">No Aplica</span>;
    //     }
    //     // Si es PRESENCIAL o cualquier otro normal
    //     return (
    //       <span className={`badge ${row.fechaAltaRelojAccesos ? 'bg-success' : 'bg-warning text-dark'}`}>
    //         {row.fechaAltaRelojAccesos ? 'Confirmado' : 'Pendiente'}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   name: 'AltaEnSistemas',
    //   width: '110px',
    //   cell: (row: DTOEmpleado) => (
    //     <Badge bg={row.altaEnSistemas ? 'success' : 'warning'} text={row.altaEnSistemas ? 'light' : 'dark'}>
    //       {row.altaEnSistemas ? 'Completado' : 'Pendiente'}
    //     </Badge>
    //   ),
    // },

    {
  name: 'Reloj&Acceso',
  width: '150px',
  cell: (row: DTOEmpleado) => {
    if (row.modalidad === 'LabHome') return <span className="badge bg-info text-dark">Reloj Virtual</span>;
    if (row.modalidad === 'NoInOut' || row.modalidad === 'On') return <span className="badge bg-secondary">No Aplica</span>;

    if (!row.activo) {
      // IT confirma mediante la fechaBajaAccesosReloj
      const isDone = row.fechaBajaAccesosReloj ? true : false;
      return (
        <span className={`badge ${isDone ? 'bg-danger' : 'bg-dark'}`}>
          {isDone ? 'Baja Confirmada' : 'Pendiente Baja'}
        </span>
      );
    }

    return (
      <span className={`badge ${row.fechaAltaRelojAccesos ? 'bg-success' : 'bg-warning text-dark'}`}>
        {row.fechaAltaRelojAccesos ? 'Confirmado' : 'Pendiente'}
      </span>
    );
  },
},
{
  name: 'AltaEnSistemas',
  width: '150px',
  cell: (row: DTOEmpleado) => {
    if (!row.activo) {
      // IT confirma mediante la fechaBajaSistemas
      const isDone = row.fechaBajaSistemas ? true : false;
      return (
        <Badge bg={isDone ? 'danger' : 'dark'}>
          {isDone ? 'Baja Completada' : 'Baja Pendiente'}
        </Badge>
      );
    }

    return (
      <Badge bg={row.altaEnSistemas ? 'success' : 'warning'} text={row.altaEnSistemas ? 'light' : 'dark'}>
        {row.altaEnSistemas ? 'Completado' : 'Pendiente'}
      </Badge>
    );
  },
},
    { 
      name: 'Baja Reloj', 
      selector: (row: DTOEmpleado) => row.fechaBajaAccesosReloj ? new Date(row.fechaBajaAccesosReloj).toLocaleDateString() : 'N/A', 
      sortable: true, 
      width: '130px' 
    },
    { 
      name: 'Baja IT', 
      selector: (row: DTOEmpleado) => row.fechaBajaSistemas ? new Date(row.fechaBajaSistemas).toLocaleDateString() : 'N/A', 
      sortable: true, 
      width: '130px' 
    },
    {
      name: 'Acciones',
      width: '110px',
      cell: (row: DTOEmpleado) => (
        <BsShieldCheck
          size={22}
          color="#0d6efd"
          title="Configurar Accesos IT"
          onClick={() => handleOpenModalSistemas(row)}
          style={{ cursor: 'pointer' }}
        />
      ),
    }, 

    // En tu definición de columnsSistemas añade este icono/botón:
// {
//   name: 'AccesosSistemas',
//   width: '110px',
//   cell: (row: DTOEmpleado) => (
//     <Button 
//         variant="outline-dark" 
//         size="sm" 
//         onClick={() => handleOpenKeys(row.numEmpleado)}
//     >
//       🔑 Accesos
//     </Button>
//   ),
// }
  ]

  return (
    <div className="mt-2">
      <Card style={{ width: '100%', height: '100%' }}>
        <Card.Body style={{ padding: '10px 20px' }}> {/* Padding reducido para móvil */}
          <div className="container-fluid px-0">
            
            {/* --- CONTROLES SUPERIORES (RESPONSIVOS) --- */}
            <div className="mb-3">
              <Card className="p-2 w-100">
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                  <div style={{ flex: '1 1 250px' }}>
                    <Form.Control
                      type="text"
                      size="sm"
                      placeholder="Buscar por nombre o número..."
                      onChange={filtraReporte}
                      className="w-100"
                    />
                  </div> 

              <Col xs="auto">
                <Form.Select
                  size="sm"
                  value={estatusFiltro}
                  onChange={(e) => setEstatusFiltro(e.target.value)}
                  style={{ height: '35px', width: '150px', cursor: 'pointer', fontWeight: 'bold' }}
                  className={estatusFiltro === 'inactivos' ? 'text-danger' : estatusFiltro === 'activos' ? 'text-success' : ''}
                >
                  <option value="todos">Todos</option>
                  <option value="activos">Solo Activos</option>
                  <option value="inactivos">Solo Bajas</option>
                </Form.Select>
              </Col>

              
                  


                  
                  <div className="d-flex gap-2">
                    <Button variant="primary" size="sm" onClick={generarReporte} className="d-flex align-items-center gap-1">
                      <BsSearch /> Buscar
                    </Button>
                    <Button variant="success" size="sm" onClick={downloadExcel} className="d-flex align-items-center gap-1">
                      <BsFileEarmarkExcel /> Excel
                    </Button>
                  </div>
                </div>
              </Card>
            </div>

            {/* --- TABLA DE DATOS --- */}
            <Row>
              <Col xs={12}>
                <Card style={{ width: '100%', height: '65vh' }}> {/* Altura adaptativa */}
                  <Card.Body className="p-0 h-100" style={{ overflow: 'auto' }}>
                    <DataTable
                      noHeader
                      striped={true}
                      dense={true}
                      paginationPerPage={10}
                      pagination
                      highlightOnHover
                      columns={columnsSistemas}
                      data={filteredData}
                      pointerOnHover
                      responsive={true}
                      customStyles={{
                        headCells: { style: { fontWeight: 'bold', backgroundColor: '#f8f9fa', fontSize: '14px' } },
                        rows: { style: { minHeight: '45px', fontSize: '13px' } }, // Fuente un poco más chica para móvil
                      }}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>

          </div>
        </Card.Body>
      </Card>

      
      <Modal show={showModalSistemas} onHide={handleCloseModalSistemas} size="lg" backdrop="static" centered>
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title className="h6 mb-0">Configuración IT - {name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
             
              <Col xs={12} lg={6} className="mb-4 mb-lg-0 pr-lg-3">
                <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">1. Información del Empleado</h6>
                
                <Row>
                  <Col xs={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="text-muted small mb-0 fw-bold">No. Empleado</Form.Label>
                      <Form.Control type="text" value={numEmpleado} disabled size="sm" className="bg-light" />
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="text-muted small mb-0 fw-bold">ID Reloj</Form.Label>
                      <Form.Control type="text" value={ac} disabled size="sm" className="bg-light" />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-2">
                  <Form.Label className="text-muted small mb-0 fw-bold">Nombre</Form.Label>
                  <Form.Control type="text" value={name} disabled size="sm" className="bg-light" />
                </Form.Group>

                <Row>
                  
                  <Col xs={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="text-muted small mb-0 fw-bold">Oficina</Form.Label>
                      <Form.Control type="text" value={oficina} disabled size="sm" className="bg-light" />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col xs={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="text-muted small mb-0 fw-bold">Estatus Actual</Form.Label>
                      <div className="d-block mt-1">
                        <Badge bg={activo ? 'success' : 'danger'} className="p-2 w-100">
                          {activo ? 'EMPLEADO ACTIVO' : 'DADO DE BAJA'}
                        </Badge>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="text-muted small mb-0 fw-bold">Fecha de Baja</Form.Label>
                      <Form.Control 
                        type="text" 
                        value={fechaBajaEfectiva ? new Date(fechaBajaEfectiva).toLocaleDateString() : 'N/A'} 
                        disabled 
                        size="sm" 
                        style={{ backgroundColor: fechaBajaEfectiva ? '#f8d7da' : '#e9ecef', color: '#000', fontWeight: fechaBajaEfectiva ? 'bold' : 'normal' }} 
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>

              {/* --- COLUMNA DERECHA: ACCIONES IT --- */}
              <Col xs={12} lg={6} className="border-lg-start ps-lg-4 mt-3 mt-lg-0" style={{ borderLeft: window.innerWidth > 992 ? '1px solid #dee2e6' : 'none' }}>
                <h6 className="text-success border-bottom pb-2 mb-3 fw-bold">2. Checklist de Sistemas</h6>

                <Form.Group className="mb-4 mt-3 p-3 bg-light rounded border">
                  



                {modalidad === 'PRESENCIAL' || !modalidad ? (
                  <Form.Group className="mb-4 mt-3 p-3 bg-light rounded border">
                    <Form.Check 
                      type="switch"
                      id="check-reloj"
                      label="Acceso a Reloj Confirmado"
                      checked={tieneAccesosReloj}
                      onChange={(e) => setTieneAccesosReloj(e.target.checked)}
                      style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#0d6efd' }}
                    />
                    <Form.Text className="text-muted d-block mt-1" style={{ fontSize: '0.8rem' }}>
                      Marca esto cuando la huella o rostro ya estén activos en el checador físico.
                    </Form.Text>
                  </Form.Group>
                ) : (
                  <Form.Group className="mb-4 mt-3 p-3 bg-light rounded border text-center">
                    <span className="fw-bold text-secondary" style={{ fontSize: '1.1rem' }}>
                      {modalidad === 'LABHOME' ? '💻 Usa Reloj Virtual' : '🚫 No requiere Reloj'}
                    </span>
                    <Form.Text className="text-muted d-block mt-1">
                      Por su modalidad (<b>{modalidad}</b>), IT no necesita darle acceso en el checador físico.
                    </Form.Text>
                  </Form.Group>
                )}
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label style={{ fontWeight: 'bold' }}>Correo Corporativo Asignado</Form.Label>
                  <Form.Control 
                    type="email" 
                    placeholder="ej. usuario@gemcousa.com"
                    value={correoEmpresa}
                    onChange={(e) => setCorreoEmpresa(e.target.value)} 
                    className="border-primary"
                  />
                </Form.Group>

                

                {/* ---> NUEVO: CAJA DE TEXTO PARA COMENTARIOS DE IT <--- */}
                <Form.Group className="mb-4">
                  <Form.Label style={{ fontWeight: 'bold' }}>Notas o Comentarios Adicionales (Opcional)</Form.Label>
                  <Form.Control 
                    as="textarea" 
                    rows={2}
                    placeholder="Escribe alguna nota para Recursos Humanos o para el historial..."
                    value={comentariosSistemas}
                    onChange={(e) => setComentariosSistemas(e.target.value)} 
                    className="border-warning bg-light"
                  />
                  <Form.Text className="text-muted d-block mt-1" style={{ fontSize: '0.8rem' }}>
                    Si escribes algo aquí, Recursos Humanos lo verá resaltado en su correo.
                  </Form.Text>
                </Form.Group>
                {/* -------------------------------------------------------- */}

                    






                <div className="p-3 rounded border" style={{ backgroundColor: altaEnSistemas ? '#d1e7dd' : '#f8f9fa', borderColor: altaEnSistemas ? '#badbcc' : '#dee2e6' }}>
                  <Form.Group>
                    <Form.Check 
                      type="checkbox"
                      id="check-alta-sistemas"
                      label="Alta de IT Finalizada"
                      checked={altaEnSistemas}
                      onChange={(e) => setAltaEnSistemas(e.target.checked)}
                      className={altaEnSistemas ? 'text-success' : 'text-dark'}
                      style={{ fontSize: '1.1rem', fontWeight: 'bold' }}
                    />
                    <Form.Text className="text-muted d-block mt-1" style={{ fontSize: '0.8rem' }}>
                      Al guardar con esta casilla marcada, Recursos Humanos recibirá un correo de confirmación.
                    </Form.Text>
                  </Form.Group>
                </div>

              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button variant="outline-secondary" onClick={handleCloseModalSistemas}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleSaveSistemas} className="d-flex align-items-center gap-2">
            <BsShieldCheck size={18} /> Guardar Cambios
          </Button>
        </Modal.Footer>
      </Modal>

      {/* --- MODAL PARA CONTROL DE CONTRASEÑAS --- */}
<Modal show={showModalKeys} onHide={() => setShowModalKeys(false)}  fullscreen={true} >
    <Modal.Header closeButton>
        <Modal.Title>Gestión de Credenciales</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {/* Pasamos el número de empleado para que el componente ya sepa a quién buscar */}
        <ControlContrasenas numEmpleadoInicial={selectedNumEmp} />
    </Modal.Body>
</Modal>



      {/* --- TOAST / MENSAJE --- */}
      <MsgInformativo
        show={show}
        msg={msg}
        header={header}
        msgColor={msgColor}
        closeToast={() => setShowMsg(false)}
      />
    </div>
  )
}